export default __webpack_public_path__ + "images/arrow-left-branded-blue.v-d0393c05742ffca7354616a0431d9d0f.svg";